import * as React from 'react';

import { GridMonthProps } from '../../components/grid/month';
import GridDay from '../../components/grid/day';
import moment = require('moment');

const GridMonthView: React.StatelessComponent<GridMonthProps> = props => {
    const hasEvents = props.monthData.events.days.some(day => day.events.length > 0);
    const eventsToDisplay = props.monthData.events.days.filter(day => day != null && moment().startOf('week').isSameOrBefore(day.date))
    if (hasEvents) {
        return (
            <li className="ace-cal-grid-month">
                <section>
                    <h3 className="ace-cal-grid-month-name h2-style" id={`Month-${props.monthData.monthMoment.format("X")}`}>{props.monthData.monthMoment.format("MMMM YYYY")}</h3>
                    <ul className="ace-cal-grid-days" aria-labelledby={`Month-${props.monthData.monthMoment.format("X")}`}>
                        {
                            eventsToDisplay.map(day => props.monthData.monthMoment.month() === day.date.getMonth() ? <GridDay key={day.date.toDateString()} day={day} /> : <li key={day.date.toDateString()} className="ace-cal-grid-day-empty" aria-hidden="true"></li>)
                        }
                    </ul>
                </section>
            </li>
        );
    } else {
        return (
            <li className="ace-cal-grid-month">
                <section>
                    <h3 className="ace-cal-grid-month-name h2-style" id={`Month-${props.monthData.monthMoment.format("X")}`}>{props.monthData.monthMoment.format("MMMM YYYY")}</h3>
                    <div className="ace-cal-grid-days-empty" dangerouslySetInnerHTML={{ __html: props.text.emptyMonthMessage }} aria-labelledby={`Month-${props.monthData.monthMoment.format("X")}`}></div>
                </section>
            </li>
        )
    }
}

export default GridMonthView;